import { Toaster } from "@components";
import { ModalProvider, ReactQueryProvider, SentryProvider } from "@providers";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProviderWrapper } from "@/providers/i18n-provider";
import { RouteProvider } from "@/providers/router-provider";
import { Theme } from "@/providers/theme";
import { ToastProvider } from "@/providers/toast-provider";
import { AnalyticsTracker } from "@/shared/components/AnalyticsTracker";
import { Routes } from "./routes";

export default function App() {
	return (
		<SentryProvider>
			<AuthProvider>
				<ReactQueryProvider>
					<I18nProviderWrapper>
						<RouteProvider>
							<AnalyticsTracker />
							<Theme>
								<Toaster />
								<ToastProvider>
									<ModalProvider>
										<Routes />
									</ModalProvider>
								</ToastProvider>
							</Theme>
						</RouteProvider>
					</I18nProviderWrapper>
				</ReactQueryProvider>
			</AuthProvider>
		</SentryProvider>
	);
}
